const DAY_MILLISECONDS = 86_400_000;

// Rounded up, so a version still kept is never said to have no days left.
export const daysUntilExpiry = ({ expiresAt, now }: { expiresAt: string; now: string }) =>
  Math.max(1, Math.ceil((Date.parse(expiresAt) - Date.parse(now)) / DAY_MILLISECONDS));
